export const CARTRIDGE_TYPE = {
  DEFAULT: 'default',
  CIRCUIT: 'circuit',
  LASER: 'laser',
  CHIP: 'chip'
}
